import React from 'react'
import { cva } from 'class-variance-authority'
import { cn } from '~/lib/utils'

export const boxVariants = cva('box', {
  variants: {
    variant: { default: 'relative', outlined: 'relative rounded-2.5xl border' },
    density: { default: 'p-6', compact: 'p-3', roomy: 'p-10' },
    color: {
      default: 'bg-white border-cod-gray-300',
      primary: 'bg-intoo-blue-medium-50 border-intoo-blue-medium-200',
      'primary-light': 'bg-white border-intoo-blue-medium-700',
      secondary: 'bg-willow-brook-25 border-willow-brook-200',
      'secondary-light': 'bg-white border-intoo-green-medium-700',
      select: 'bg-select-blue text-white',
      'select-light': 'bg-select-blue-light border-none',
    },
    shadow: { default: 'shadow-none', medium: 'shadow-md' },
  },
  defaultVariants: {
    variant: 'default',
    density: 'default',
    color: 'default',
    shadow: 'default',
  },
})

const Box = React.forwardRef(
  ({ className, variant, density, color, shadow, ...props }, ref) => {
    return (
      <div
        className={cn(
          boxVariants({ variant, density, color, shadow, className }),
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Box.displayName = 'Box'

export default Box
